<template>
  <div class="com">
    <div class="compare-to">
      <div :class="isDateSelectionDisabled">
        <div class="note ri">
            <span id="txt_dataMissing_right">
              {{ $t('CompareOimComponent.notEnoughDataAvailable') }}
            </span>
        </div>
        <div class="list-items" @click.prevent="toggleShowSelection">
          <div class="item checked" id="yourself_right">
              <span class="item-text" id="txt_yourself_right">
                {{ getSelectedMonth.label }}
              </span>
            <span class="checkbox">
                <i class="fa-solid fa-circle-check check-icon">
                  <font-awesome-icon icon="fa-solid fa-circle-check check-icon"/>
                </i>
              </span>
          </div>
        </div>
      </div>
      <div class="team-compare" v-if="showSelection">
        <ul class="list-items" id="list-items">
          <li :class="isDateChecked(month)"
              v-for="month in getCompareMonthSelection"
              :key="month"
              @click.prevent="selectMonth(month)">
              <span class="item-text">
               {{ month.label }}
              </span>
            <span class="checkbox">
                <i class="fa-solid fa-circle-check check-icon">
                  <font-awesome-icon icon="fa-circle-check"/>
                </i>
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashboardDateSelectComponent',
  data() {
    return {
      showSelection: false,
    };
  },
  computed: {
    lang() {
      return this.$i18n.locale;
    },
    isDateSelectionDisabled() {
      if (this.$store.state.dashboard.compareMonthSelection.length === 0
      || !this.$store.state.dashboard.selectedCompareMonth) {
        return 'yourself-compare disabled';
      }
      return 'yourself-compare';
    },
    getSelectedTeam() {
      return this.$store.state.dashboard.selectedTeam;
    },
    getSelectedMonth() {
      if (!this.$store.state.dashboard.selectedCompareMonth) {
        return { label: '-', value: null };
      }
      const date = new Date(this.$store.state.dashboard.selectedCompareMonth);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-based
      return { label: `${year}-${month}`, value: date };
    },
    getCompareMonthSelection() {
      return this.$store.state.dashboard.compareMonthSelection.map((value) => {
        const date = new Date(value);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-based
        return { label: `${year}-${month}`, value };
      });
    },
  },
  methods: {
    toggleShowSelection() {
      this.showSelection = !this.showSelection;
    },
    isDateChecked(toCompare) {
      if (toCompare.label === this.getSelectedMonth.label) {
        return 'item checked';
      }
      return 'item';
    },
    async selectMonth(item) {
      try {
        this.toggleShowSelection();
        this.$store.commit('setIsDashboardLoading', true);
        if (item !== this.getSelectedMonth) {
          this.$store.commit('setSelectedCompareMonth', item.value);
          await this.$store.dispatch('getTeamDashboardPlots');
        }
        this.$store.commit('setIsDashboardLoading', false);
      } catch (error) {
        this.$store.commit('setIsDashboardLoading', false);
        this.$toast.add({
          severity: 'error',
          summary: error.response?.data?.message,
          detail: '',
          life: 3000,
        });
      }
    },
  },
};
</script>

<style scoped>
/*------------------ COMPARE TO -------------------*/
.box .content .oim h2 {
  font-size: 23px;
  padding: 50px 0 10px;
}

.com {
  display: flex;
  box-sizing: border-box;
  border-radius: 0px 0px 20px 20px;
  width: 100%;
  max-width: 300px;
  cursor: pointer;
  padding-bottom: 8px;
  padding-left: 20px;
}

.compare-to {
  width: 100%;
  height: auto;
}

.compare-to .list-items {
  display: block;
  max-height: 200px;
  overflow-y: scroll;
}

.compare-to .list-items::-webkit-scrollbar {
  width: 5px;
  background: transparent;
  border-radius: 0 8px 8px 0;
}

.compare-to .list-items::-webkit-scrollbar-thumb {
  background: var(--color-disabled);
  border-radius: 0 8px 8px 0;
  pointer-events: none;
}

.list-items {
  width: 100%;
  max-height: 0;
  border-radius: 8px;
  padding: 0.5rem 1rem;
  margin-bottom: 10px;
  border: 1px solid var(--color-light-grey);
  box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.2);
  background-color: var(--color-milk);
  overflow: hidden;
  z-index: 10;
}

.list-items .item {
  display: flex;
  align-items: center;
  margin-top: 15px;
  margin-bottom: 15px;
  justify-content: space-between;
  height: 40px;
  cursor: pointer;
  transition: 0.3s;
  overflow-wrap: break-word;
}

.list-items .item:hover {
  transform: scale(1.02);
}

.list-items .item .item-text {
  display: flex;
  align-items: center;
}

.list-items .item .item-text img {
  width: 2rem;
  margin-right: 12px;
}

.list-items .item .checkbox {
  margin-left: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  width: 20px;
  border: 1px solid var(--color-dark);
  border-radius: 50px;
  transition: all 0.3s ease-in-out;
}

.checkbox .check-icon {
  color: var(--color-orange);
  font-size: 24px;
  transform: scale(0);
  transition: all 0.3s ease-in-out;
}

/*".item" auf "checked"-Klasse setzten, wenn angeklickt. Dann erscheint Häckchen.*/
.item.checked .check-icon {
  transform: scale(1);
}

/*------------------ DISABLED -------------------*/
/*".yourself-compare" auf "disabled"-Klasse gesetzt,
 dann ist yourself nicht auswählbar für Vergleich*/
.compare-to .yourself-compare.disabled > .list-items {
  color: var(--color-disabled);
  pointer-events: none;
}

.compare-to .yourself-compare.disabled > .list-items .checkbox {
  border: 1px solid var(--color-disabled);
  background-color: var(--color-disabled);
}

.compare-to .yourself-compare.disabled > .list-items .item:hover {
  transform: none;
  cursor: auto;
  pointer-events: none;
}

/*------------------ POPUP: NOTE -------------------*/
.com .compare-to .yourself-compare .note {
  position: relative;
  width: 270px;
  padding: 10px;
  margin-bottom: 7px;
  border-radius: 10px;
  color: white;
  background-color: var(--color-orange);
  box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.2);
  opacity: 0;
  pointer-events: none;
  text-align: center;
}

.com .compare-to .yourself-compare.disabled .note.re {
  right: 5px;
}

.com .compare-to .yourself-compare.disabled .note.re {
  left: 5px;
}

.com .compare-to .yourself-compare.disabled:hover .note {
  opacity: 1;
}

/*kleines Viereck am unteren Ende des Kästchens*/
.com .compare-to .yourself-compare.disabled .note::before {
  position: absolute;
  content: "";
  height: 15px;
  width: 15px;
  background-color: var(--color-orange);
  bottom: -8px;
  left: 25%;
  transform: translateX(-50%) rotate(45deg);
}

.team-compare {
  position: absolute;
  z-index: 10;
}

</style>
